(() => {
  function initialize(root = document) {
    const dialog = document.getElementById('sm-reviews-dialog');
    document.querySelectorAll('[data-sm-loox-count]').forEach(element => {
      const count = Number(element.textContent.trim());
      if (Number.isSafeInteger(count) && count > 0) element.textContent = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL').format(count);
    });
    root.querySelectorAll('[data-sm-open-reviews]').forEach(button => {
      if (button.dataset.smBound || !dialog) return;
      button.dataset.smBound = 'true';
      button.addEventListener('click', () => {
        if (dialog.open) return;
        dialog.smOpener = button;
        dialog.showModal();
        document.documentElement.classList.add('sm-review-dialog-open');
        dialog.querySelector('.sm-review-dialog-body').scrollTop = 0;
        window.dispatchEvent(new Event('resize'));
      });
    });
    if (dialog && !dialog.dataset.smBound) {
      dialog.dataset.smBound = 'true';
      dialog.querySelector('[data-sm-close-reviews]').addEventListener('click', () => dialog.close());
      let onBackdrop = false;
      const outside = event => {
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      };
      dialog.addEventListener('pointerdown', event => { onBackdrop = event.target === dialog && outside(event); });
      dialog.addEventListener('click', event => {
        if (onBackdrop && event.target === dialog && outside(event)) dialog.close();
        onBackdrop = false;
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('sm-review-dialog-open');
        if (dialog.smOpener?.isConnected) dialog.smOpener.focus({preventScroll:true});
      });
    }
    root.querySelectorAll('.sm-homepage-companies marquee-element').forEach(marquee => {
      marquee.setAttribute('data-speed', window.matchMedia('(max-width:749px)').matches ? '10' : '5');
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', () => initialize());
  document.addEventListener('shopify:section:unload', () => document.documentElement.classList.remove('sm-review-dialog-open'));
})();
